module.exports = __webpack_public_path__ + "img/no_data.11d02f30.svg";